// コメント種別
export enum ReceptionCommentKinds {
  Comment,
  Restrict,
  NextMessage,
  BackMessage,
  ContactedInfo,
  Delete,
  Conflict,
}

export class ReceptionCommentKindsName {
  
  static getTypeName(value: ReceptionCommentKinds) {
    if (value === ReceptionCommentKinds.Comment) { return "Comment"; }
    if (value === ReceptionCommentKinds.Restrict) { return "Restricted"; }
    if (value === ReceptionCommentKinds.NextMessage) { return "NextMessage"; }
    if (value === ReceptionCommentKinds.BackMessage) { return "BackMessage"; }
    if (value === ReceptionCommentKinds.ContactedInfo) { return "ContactedInfo"; }
    if (value === ReceptionCommentKinds.Delete) { return "DelComment"; }
    if (value === ReceptionCommentKinds.Conflict) { return "Conflict"; }

    return "";
  }

  static toKind(name: string): ReceptionCommentKinds {
    switch (name) {
      case "Comment":
        return ReceptionCommentKinds.Comment;
      case "Restricted":
        return ReceptionCommentKinds.Restrict;
      case "NextMessage":
        return ReceptionCommentKinds.NextMessage;
      case "BackMessage":
        return ReceptionCommentKinds.BackMessage;
      case "ContactedInfo":
        return ReceptionCommentKinds.ContactedInfo;
      case "DelComment":
        return ReceptionCommentKinds.Delete;
      case "Conflict":
        return ReceptionCommentKinds.Conflict;
      default:
        return null;
    }
  }
}

